import { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UIContext } from 'Context/UI'
import { useProductionStore } from 'Store/Production'
import { shallow } from 'zustand/shallow'
import Swal from 'sweetalert2'

const ViewModel = () => {
	const navigate = useNavigate()
	const { setCustomContentToolbar, setShowContentToolbar } = useContext(UIContext)
	const { productLines, getProductLines } = useProductionStore(
		state => ({
			productLines: state.productLines,
			getProductLines: state.getProductLines,
		}),
		shallow
	)
	const [isLoading, setIsLoading] = useState(false)

	const createNewProductLine = () => {
		navigate('/general/production/product-lines')
	}

	const editProductLine = (id: number, hasChild: boolean) => {
		if (hasChild) {
			navigate(`/general/production/${id}`)
		} else if (!hasChild) {
			navigate(`/general/production/${id}/properties`)
		}
	}

	const fetchData = () => {
		setIsLoading(true)
		getProductLines().then(({ data, success }) => {
			if (!success) {
				Swal.fire({
					title: 'ดึงข้อมูลไม่สำเร็จ',
					text: data,
					icon: 'error',
					confirmButtonText: 'ปิด',
					customClass: {
						confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
					},
				})
			}

			setIsLoading(false)
		})
	}

	// Toolbar
	useEffect(() => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		fetchData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		createNewProductLine,
		editProductLine,
		productLines,
		isLoading,
	}
}

export default ViewModel
